import $ from 'jquery'

const hostname = window.location.hostname;
export const arr = hostname.split(".");

export const API_HOST = "gactivityapi."+arr[1]+".com";
const baseUrl =`//${API_HOST}/activity/execute?name=dlssrvtline2&action=`;
const loginUrl = `//gpassport.${arr[1]}.com/center/ajax/get_user_json`
const logoutUrl = `//gpassport.${arr[1]}.com/web_login/logout`
const basicUrl = `${baseUrl}matchConfig`
const bindUrl = `${baseUrl}bindRole`
const historyQuizUrl = `${baseUrl}historyQuiz`
const matchQuizUrl = `${baseUrl}matchQuiz`
const serverUrl = `${baseUrl}listServer`
const characterUrl = `${baseUrl}getMobileGameRole`

const ajax = {
  request(param) {
    return new Promise((resolve, reject) => {
      $.ajax({
        type: param.method || 'get',
        url: param.url || '',
        data: param.data || '',
        dataType: param.type || 'jsonp',
        jsonp: 'callback',
        success: function (res) {
          resolve(res)
        },
        error: function (errMsg) {
          reject(errMsg)
        }
      })
    })
  }
}

const api = {
  getBasicInfo() {
    const params = {
      url: basicUrl
    }
    return ajax.request(params)
  },
  bind({ serverId, roleId, serverName, roleName ,sId}) {
    const params = {
      url: bindUrl,
      data: {
        params: JSON.stringify({
          serverId,
          roleId,
          serverName,
          roleName,
          sId
        })
      }
    }
    return ajax.request(params)
  },
  history() {
    const params = {
      url: historyQuizUrl
    }
    return ajax.request(params)
  },
  match(matchId) {
    const params = {
      url: matchQuizUrl,
      data: {
        params: JSON.stringify({
          matchId
        })
      }
    }
    return ajax.request(params)
  },
  checkLogin() {
    const params = {
      url: loginUrl
    }
    return ajax.request(params)
  },
  logout() {
    const params = {
      url: logoutUrl
    }
    return ajax.request(params)
  },
  getServer() {
    const params = {
      url: serverUrl
    }
    return ajax.request(params)
  },
  getCharacter(server_id) {
    const params = {
      url: characterUrl,
      data: {
        params: JSON.stringify({
          server_id
        })
      }
    }
    return ajax.request(params)
  }
}
export default api
